import toggleVisibility from '../toggleVisibility';

const updateSelectedVariant = ({ variant, variantInventory = [], elements = {}, strings = {} }) => {
  const {
    productSoldInfo,
    productControls,
    klaviyoBIS,
    atcButton,
    atcButtonMsg
  } = elements;

  const current = variantInventory.find(v => v.id === variant.id);
  const isPreOrder = current && !current.available && current.inventory_policy === 'continue';
  const isSoldOut = !variant.available && !isPreOrder;
  const isAvailable = variant.available;

  if (productSoldInfo) toggleVisibility(productSoldInfo, !isPreOrder && isAvailable);
  if (klaviyoBIS) toggleVisibility(klaviyoBIS, isSoldOut);
  if (productControls) toggleVisibility(productControls, isAvailable);

  const getAtcBtnText = () => {
    if (isSoldOut) return strings.soldOut;
    if (isPreOrder) return strings.preOrder;
    return strings.addToCart;
  };

  if (atcButtonMsg) {
    const text = getAtcBtnText();
    atcButtonMsg.textContent = text;
    atcButton?.setAttribute('aria-label', text);
  }
};

export default updateSelectedVariant;
